import {Component, ViewChild} from '@angular/core';
import {
    ColumnFilter,
    ContactLight,
    ContactService,
    DataFilter,
    DataTableColumnData,
    DatatableComponent,
    DataTableConfig,
    DataTablePaginatedDataSource,
    PaginatedRequest,
    TableAction
} from '@cas-hub/acabim-common-client';
import {MessageService} from 'primeng/api';
import {ContactFilter, ContactSetterService} from '../../_services/contact-setter.service';
import {FileRemovalInput, FileUsageInput} from './contact-detail/contact-detail.component';
import {FormGroup} from '@angular/forms';
import {ContactRoleType} from '../../_models/contact-details.model';

@Component({
    selector: 'acabim-admin-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss'],
    providers: [MessageService]

})
export class ContactComponent extends DataTablePaginatedDataSource<ContactLight> {

    public readonly columnData: DataTableColumnData[] =
        [
            {displayName: 'Name', objectPropertyName: 'userName'},
            {displayName: 'First Name', objectPropertyName: 'firstName'},
            {displayName: 'Family Name', objectPropertyName: 'familyName'},
            {displayName: 'Contact Type', objectPropertyName: 'contactType'},
            {displayName: 'Role Type', objectPropertyName: 'roleType'},
            {displayName: 'Email', objectPropertyName: 'email'},
            {displayName: 'Phone', objectPropertyName: 'phone'},
            {
                displayName: 'Registration',
                objectPropertyName: 'registered',
                colWidth: '6rem',
                textAlign: 'center',
                callback: (val: number) => {
                    switch (val) {
                        case 1:
                            return 'Invited';
                        case 2:
                            return 'Registered';
                        default:
                            return ' – ';
                    }
                }
            }
        ];

    public readonly config: DataTableConfig = {
        tableHeading: 'Contact',
        isSearchEnabled: true,
        searchPlaceHolder: '',
        emptyMessage: 'No contact found',
        globalFilterFields: [],
        hasDetailsButton: true,
        hasCheckbox: true,
        isPaginationEnabled: true,
        isLazyLoadingEnabled: true,
        hasFilters: true,
        isExportEnabled: true,
        hasActions: true,
        datatableUpdateId: 'Contacts'
    };

    public readonly columnFilters: ColumnFilter[] = ContactFilter.getFilters();
    public readonly actions: TableAction[] = [
        {name: 'Archive', id: 0},
        {name: 'Role ⇒ ' + ContactRoleType[ContactRoleType.Maintenance], id: 1},
        {name: 'Role ⇒ ' + ContactRoleType[ContactRoleType.Administration], id: 2},
        {name: 'Role ⇒ ' + ContactRoleType[ContactRoleType.External], id: 3}
    ];

    public isLoading = false;

    public get selectedContactId(): string {
        return this.detailData?.id.toString() ?? '';
    }

    // private get contactProperties(): Observable<Contact> {
    //     return this.contactSetter.getContactProperties(this.selectedContactId);
    // }

    constructor(
        private readonly contactService: ContactService,
        private readonly contactSetter: ContactSetterService,
        private readonly messageService: MessageService
    ) {
        super((pagination: PaginatedRequest, filters?: DataFilter[]) => {
            return this.contactService.getContactsLight(pagination, filters);
        }, (tableName: string, error: Error) => {
            this.messageService.clear();
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Error in retrieving data in table ' + tableName
            });
        });
    }

    @ViewChild('dataTable') public dataTable!: DatatableComponent;

    public showError = false;
    public add = false;
    public addContact = false;
    public delete = false;
    public totalRecords = 0;
    public errorMessage?: any;

    onDataExpanded(value: ContactLight): void {
    }

    onAction(action: TableAction): void {
        switch (action.id) {
            case 0:
                this.delete = true;
                break;
            case 1:
                this.assignRole(ContactRoleType[ContactRoleType.Maintenance]);
                break;
            case 2:
                this.assignRole(ContactRoleType[ContactRoleType.Administration]);
                break;
            case 3:
                this.assignRole(ContactRoleType[ContactRoleType.External]);
                break;
            default:
                break;
        }
    }

    click() {
        this.add = true;
    }

    addContactCall(): void {
        this.add = false;
        this.addContact = true;
    }

    submit(result: boolean) {
        if (result) {
            this.dataTable?.requestImmediateDataRefresh();
            this.addContact = false;
            this.showDetails = false;
        }
    }

    deleteData() {
        if (this.selectedData.length > 0) {
            for (const data of this.selectedData) {
                const index = this.selectedData.indexOf(data);
                this.contactSetter.deleteContact(data.id).subscribe(d => {
                    this.dataTable?.requestImmediateDataRefresh();
                    this.delete = false;

                    if (index === this.selectedData.length - 1) {
                        this.selectedData = [];
                    }
                });
            }
        }
    }

    assignRole(roleType: string) {
        if (this.selectedData.length > 0) {
            const contactIds: number[] = this.selectedData.map(d => d.id);
            this.contactSetter.assignRole(roleType, contactIds).subscribe(res => {
                console.dir(res);
                this.dataTable?.requestImmediateDataRefresh();
                this.selectedData = [];
            });
        }
    }
    deleteAction(out: string) {
        if (out === 'delete') {
            this.deleteData();
        } else {
            this.delete = false;
        }
    }

    getEditForm(value: FormGroup) {
        if (value) {
            this.dataTable?.requestImmediateDataRefresh();
        }
        this.showDetails = false;
    }

    findPropertyName(displayName: string): string | null {
        const results = this.columnData.filter(entry => entry.displayName === displayName);

        if (results.length > 0) {
            return results[0].objectPropertyName;
        } else if (displayName === 'Company Name') {
            return 'company_name';
        }
        return null;
    }

    toggleAddModal($event: boolean) {
        this.add = $event;
    }

    toggleDetailsModal($event: boolean) {
        this.showDetails = $event;
    }

    toggleAddContactModal($event: boolean) {
        this.addContact = $event;
    }

    toggleErrorForm($event: boolean) {
        this.showError = $event;
    }

    updateFile($event: FileUsageInput) {
        this.contactSetter.upload($event.contactID, $event.fileGUIDS).subscribe((data: any) => {
            this.messageService.clear();
            this.messageService.add({
                severity: 'success',
                summary: 'success',
                detail: 'File Uploading Result: processed: ' + data.processed + 'succeeded: ' + data.succeeded + 'failed: ' + data.failed
            });
        });
    }

    removeFile(files: FileRemovalInput) {
        this.contactSetter.removeFileGuids(files.contactID, files.fileGUIDS).subscribe((data: any) => {
            this.messageService.clear();
            this.messageService.add({
                severity: 'success',
                summary: 'success',
                detail: 'File Removing Result: processed: ' + data.processed + 'succeeded: ' + data.succeeded + 'failed: ' + data.failed
            });
        });
    }
}
